import { StyleSheet } from 'aphrodite';
import { hexToRGBA } from '../../../../models/UiUtils';
import TileBackgroundImageUrl from '../../../assets/editAutomationTemplateBackground.png';
import { THEME } from '../../../components-v2/Theme/theme';
import {
	background,
	borderColor,
	brandPrimary,
	brandPrimaryHover,
	brandPrimaryText,
	charmGray,
	destructive,
	grayIconFill,
	header,
	inputBorderColor,
	mention,
	mentionDark,
	nameCircles,
	spanishBlue,
	titles,
	white,
} from '../../../styles/colors';
import { CssSelectors, Layouts } from '../../../styles/styles';

const {
	colors,
	typography: { fontSizes },
	spacing,
	common,
} = THEME;

export const styleSheet = StyleSheet.create({
	timezonePicker: {
		background: white,
		borderRadius: 6,
		border: common.border,
	},
	pickerPopoverContent: {
		boxSizing: 'border-box',
		padding: `${spacing.md}px ${spacing.sm}px`,
	},
	addMediaContainer: {
		display: 'flex',
		gap: spacing.lg,
		marginTop: spacing.sm,
	},
	dateRangePickerWrapper: {
		width: '100%',
	},
	dateRangePicker: {
		borderWidth: spacing.none,
		boxShadow: 'none',
		borderRadius: spacing.none,
		margin: `0 auto ${spacing.sm}px`,
		minHeight: 292,
		...CssSelectors.allChildren(
			{
				paddingBottom: spacing.none,
			},
			'.DayPicker-wrapper'
		),
	},
	calendarIcon: {
		marginRight: spacing.sm,
	},
	clearDeadline: {
		color: brandPrimaryText,
		textDecoration: 'none',
	},
	contentContainers: {
		color: '#a7abad',
		fontSize: fontSizes.sm,
	},
	deadlineDateInput: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		paddingTop: spacing.sm,
	},
	errorMessage: {
		color: destructive,
		fontSize: fontSizes.xs,
		left: 0,
		position: 'absolute',
		top: '100%',
		whiteSpace: 'nowrap',
		margin: spacing.none,
	},
	errorMessageCustomForm: {
		top: 'auto',
		bottom: 50,
		left: 50,
	},
	eventDateButton: {
		minHeight: 20,
	},
	eventDateInput: {
		backgroundColor: background,
		border: `1px solid ${inputBorderColor}`,
		borderRadius: 6,
		display: 'inline-flex',
		padding: spacing.sm,
		position: 'relative',
		width: '100%',
		fontSize: fontSizes.sm,
		boxSizing: 'border-box',
		...CssSelectors.allChildren(
			{
				alignItems: 'center',
				display: 'inline-flex',
				width: `100%`,
			},
			'button'
		),
	},
	eventDateInputSmall: {
		width: 126,
	},
	eventEndTimeInput: {
		maxWidth: 75,
	},
	eventEndTimeInputInner: {
		width: '100%',
	},
	eventLabel: {
		color: header,
		display: 'block',
		fontSize: fontSizes.sm,
		marginBottom: spacing.sm,
	},
	eventStartTimeInput: {
		maxWidth: 75,
	},
	eventStartTimeInputInner: {
		width: '100%',
	},
	fieldset: {
		border: spacing.none,
		margin: spacing.none,
		padding: spacing.none,
		boxSizing: 'border-box',
	},
	footer: {
		display: 'flex',
		justifyContent: 'flex-end',
		margin: `${spacing.sm}px auto`,
		padding: `${spacing.sm}px 0`,
		width: 922,
		...CssSelectors.allChildren(
			{
				marginRight: spacing.md,
			},
			'button:not(:last-child)'
		),
		...CssSelectors.allChildren(
			{
				alignItems: 'center',
				borderRadius: 6,
				display: 'inline-flex',
				justifyContent: 'center',
			},
			'button'
		),
	},
	formControlWrap: {
		marginBottom: spacing.md,
		position: 'relative',
	},
	formCustomControlWrap: {
		marginBottom: spacing.md,
	},
	formControlWrapLastChild: {
		marginBottom: spacing.xxl,
	},
	formStyles: {
		display: 'flex',
		flexDirection: 'column',
	},
	freeImage: {
		paddingLeft: spacing.sm,
		paddingRight: spacing.sm,
	},
	iconButtons: {
		background: '#f9f9f9',
		border: `1px solid ${mentionDark}`,
		color: '#0D0F11',
		display: 'flex',
		fontSize: fontSizes.md,
		marginBottom: spacing.sm,
		minWidth: 142,
		padding: spacing.sm,
	},
	infoText: {
		color: header,
		fontSize: fontSizes.sm,
		marginBottom: spacing.lg,
	},
	linkIcon: {
		marginRight: spacing.sm,
	},
	logoImage: {
		height: 50,
		left: 300,
	},
	logoName: {
		maxWidth: 200,
	},
	logoRemove: {
		left: 'auto',
		marginRight: spacing.sm,
		position: 'absolute',
		right: 0,
		top: '50%',
		transform: 'translateY(-50%)',
	},
	logoWrap: {
		...Layouts.horizontalStack(12),
		border: common.border,
		borderRadius: 6,
		boxShadow: '0px 0px 6px rgba(139,139,139, 0.100034)',
		margin: `${spacing.md}px 0`,
		position: 'relative',
	},
	mainContainer: {
		...Layouts.horizontalStack(spacing.md),
		alignItems: 'stretch',
		display: 'flex',
		justifyContent: 'center',
	},
	maxWidthContainer: {
		maxWidth: 926,
		width: '100%',
		margin: `${spacing.md}px auto`,
	},
	maximumCapasityInput: {
		maxWidth: 70,
		paddingTop: spacing.sm,
		...CssSelectors.allDescendants(
			{
				width: '100%',
			},
			'input'
		),
	},
	mediaModalStyle: {
		minWidth: 500,
		width: 500,
	},
	noMargin: {
		margin: 0,
	},
	notEditableNotice: {
		color: destructive,
		fontSize: fontSizes.md,
		textAlign: 'center',
	},
	ownImage: {
		color: brandPrimary,
		fontSize: fontSizes.sm,
		marginBottom: spacing.sm,
		marginTop: spacing.sm,
	},
	previewEvent: {
		color: brandPrimary,
		fontSize: fontSizes.sm,
		...CssSelectors.allChildren(
			{
				display: 'flex',
				alignItems: 'center',
				gap: spacing.sm,
			},
			'span'
		),
	},
	saveButton: {
		alignItems: 'center',
		boxSize: 'border-box',
		height: 40,
		width: '100%',
	},
	section: {
		borderRadius: 6,
		boxSizing: 'border-box',
		padding: `${spacing.md}px ${spacing.md}px 0`,
		width: '100%',
	},
	sectionNoBorderTop: {
		borderTop: spacing.none,
	},
	bottomSectionPadding: {
		padding: `${spacing.md}px ${spacing.md}px 0`,
	},
	sectionTitle: {
		color: titles,
		marginTop: spacing.xl,
		marginBottom: spacing.md,
	},
	selectDate: {
		boxSizing: 'border-box',
		height: 40,
		width: 152,
	},
	selectDateLabel: {
		display: 'block',
		fontSize: fontSizes.xs,
		marginBottom: spacing.sm,
	},
	selectedDate: {},
	selectTimeWrap: {
		display: 'flex',
		gap: spacing.md,
		justifyContent: 'center',
		marginBottom: spacing.lg,
	},
	sourceMention: {
		color: grayIconFill,
		fontSize: fontSizes.xs,
		fontStyle: 'italic',
		minWidth: 142,
		textAlign: 'center',
	},
	submitButton: {},
	toggleText: {
		color: titles,
		cursor: 'pointer',
	},
	bottomSection: {
		background: colors.background.light,
		width: '100%',
		boxSizing: 'border-box',
		position: 'relative',
		marginBottom: spacing.md,
	},
	sectionFullWidth: {
		width: '100%',
		boxSizing: 'border-box',
		marginBottom: spacing.lg,
	},
	questionWrap: {
		marginBottom: spacing.md,
		display: 'flex',
		width: '100%',
		flexDirection: 'column',
		...CssSelectors.allChildren(
			{
				width: '100%',
			},
			'div'
		),
	},
	label: {
		fontSize: fontSizes.sm,
		color: charmGray,
		display: 'block',
		marginBottom: spacing.sm,
	},
	optionalText: {
		fontSize: 11,
	},
	questionInput: {
		marginBottom: 8,
	},
	deleteButton: {
		fontSize: 0,
		color: 'transparent',
		position: 'absolute',
		top: 17,
		right: 15,
	},
	addQuestionButton: {
		padding: spacing.md,
		width: '100%',
		textAlign: 'center',
		color: brandPrimary,
		background: hexToRGBA(brandPrimary, 0.1),
		border: `2px dashed ${brandPrimary}`,
		borderRadius: common.borderRadius,
	},
	addQuestionFooter: {
		width: '100%',
	},
	dropdownMenu: {
		transform: 'translateY(-18px)',
		borderRadius: common.borderRadius,
	},

	dropdownTrigger: {
		border: `1px solid ${borderColor}`,
		background: hexToRGBA(borderColor, 0.1),
		borderRadius: common.borderRadius,
		transform: 'translateY(22px)',
	},
	dropdownTriggerDisabled: {
		background: `${hexToRGBA(charmGray, 0.5)} !important`,
	},
	blurb: {
		color: charmGray,
		fontSize: fontSizes.xs,
		margin: `${spacing.none} ${spacing.none} ${spacing.md}px ${spacing.none}`,
	},
	optionsWrapper: {
		maxWidth: '70%',
		paddingTop: spacing.sm,
		...CssSelectors.allChildren(
			{
				marginBottom: spacing.none,
				width: '100%',
				...CssSelectors.allDescendants(
					{
						width: '100%',
					},
					'.text-input-form-field'
				),
			},
			'div'
		),
	},
	optionsWrapperDropdown: {
		...CssSelectors.allChildren(
			{
				...CssSelectors.allDescendants(
					{
						marginBottom: spacing.none,
					},
					'.text-input-form-field'
				),
			},
			'div'
		),
	},
	removeOptionButton: {
		transform: 'translateY(-2px)',
	},
	fakeCheckbox: {
		width: spacing.sm,
		height: spacing.sm,
		border: `1px solid ${charmGray}`,
		background: white,
		borderRadius: 4,
		transform: 'translateY(-2px)',
	},
	addOptionButton: {
		color: brandPrimary,
		marginTop: spacing.sm,
	},
	addOptionButtonLeftPadding: {
		paddingLeft: spacing.lg,
	},
	toggleLabel: {
		color: charmGray,
		fontSize: fontSizes.sm,
	},
	copyLinkButton: {
		...CssSelectors.allDescendants(
			{
				display: 'flex',
				alignItems: 'center',
				gap: spacing.sm,
			},
			'span'
		),
	},
	tabViewContainer: {
		position: 'relative',
		zIndex: 1,
		height: `calc(100vh - 185px)`,
	},
	tabList: {
		position: 'relative',
		zIndex: 1,
		background: white,
		borderBottom: `1px solid ${borderColor}`,
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
		marginBottom: spacing.sm,
		height: 32,
		...CssSelectors.allDescendants(
			{
				width: 'auto',
				flex: 0,
				textTransform: 'capitalize',
				fontSize: fontSizes.sm,
				padding: `${spacing.sm}px ${spacing.md}px`,
				display: 'flex',
				alignItems: 'center',
			},
			'button'
		),
	},
	tabTextError: {
		color: `${destructive} !important`,
	},
	bodyBackground: {
		backgroundImage: `url(${TileBackgroundImageUrl})`,
		backgroundRepeat: 'repeat',
		backgroundSize: 60,
		bottom: 0,
		content: '',
		display: 'block',
		height: '100%',
		left: 0,
		opacity: 0.2,
		position: 'absolute',
		right: 0,
		top: 0,
		width: '100%',
		zIndex: 0,
	},
	formContainer: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		justifyContent: 'flex-start',
		width: '100%',
		alignItems: 'center',
		padding: '40px 0',
		position: 'relative',
	},
	additionalQuestionsContainer: {
		width: '100%',
		maxWidth: 766,
		position: 'relative',
		zIndex: 1,
	},
	formMenu: {
		display: 'flex',
		gap: spacing.md,
		alignItems: 'center',
	},
	previewLink: {
		textDecoration: 'none',
		color: brandPrimary,
		fontSize: fontSizes.sm,
		display: 'flex',
		gap: spacing.sm,
		alignItems: 'center',
		'&:hover': {
			color: brandPrimaryHover,
		},
	},
	header: {
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
		position: 'relative',
		zIndex: 1,
		background: white,
		marginLeft: -spacing.md,
		marginRight: -spacing.md,
		marginBottom: spacing.none,
		padding: `${spacing.md}px ${spacing.md}px 0`,
		...CssSelectors.allDescendants(
			{
				margin: '0 0 4px',
				color: charmGray,
				fontSize: fontSizes.sm,
			},
			'label'
		),
	},
	headerInner: {
		paddingLeft: spacing.md,
	},
	introText: {
		padding: `${spacing.md}px ${spacing.lg}px !important`,
		backgroundColor: `${THEME.colors.background.main} !important`,
		...CssSelectors.allChildren(
			{
				maxWidth: 834,
				marginTop: spacing.none,
			},
			'p'
		),
	},
	editPen: {
		position: 'absolute',
		top: spacing.none,
		right: -spacing.lg,
	},
	headerNameWrap: {
		height: 59,
	},
	headerTitle: {
		fontSize: fontSizes.md,
		lineHeight: '22px', // must be in px
		color: titles,
		margin: spacing.none,
		paddingBottom: spacing.none,
		maxWidth: 725,
	},
	headerNameInputWrap: {
		minHeight: 50,
		marginBottom: spacing.sm,
	},
	surveyContainer: {
		position: 'relative',
		zIndex: 1,
		'@media screen and (min-width: 768px)': {
			paddingLeft: spacing.xxl,
			paddingRight: spacing.xxl,
		},
		alignItems: 'center',
		color: titles,
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'wrap',
		fontSize: fontSizes.sm,
		justifyContent: 'center',
		margin: '0 auto',
		padding: `${spacing.none} ${spacing.sm}px`,
		...CssSelectors.allChildren(
			{
				borderTop: `2px solid ${nameCircles}`,
			},
			':not(:first-child)'
		),
	},
	eventDetailsContainer: {
		'@media only screen and (max-width: 1023px)': {
			display: 'block',
		},
		marginBottom: spacing.lg,
		marginTop: spacing.lg,
		gap: spacing.lg,
		display: 'flex',
		maxWidth: 1024,
		width: '100%',
		position: 'relative',
		zIndex: 1,
		background: white,
	},
	eventDetailsTitle: {
		color: brandPrimaryText,
		fontSize: fontSizes.sm,
		marginBottom: spacing.sm,
	},

	previewImage: {},
	previewImageContainer: {
		'@media only screen and (min-width: 768px)': {
			flex: '1',
			minHeight: 300,
			minWidth: 300,
		},
		border: spacing.none,
		margin: '0 auto',
		minHeight: 280,
		overflow: 'hidden',
		padding: spacing.none,
		...CssSelectors.allChildren(
			{
				width: '100%',
			},
			'img'
		),
	},
	locationAreaWrap: {
		width: '100%',
		maxHeight: 200,
		overflow: 'auto',
	},
	eventPrice: {
		width: '100%',
		fontWeight: 600,
	},
	details: {
		flex: '1 1',
		textAlign: 'left',
		gap: spacing.md,
		display: 'flex',
		flexDirection: 'column',
		...CssSelectors.allDescendants(
			{
				fontWeight: 600,
				margin: spacing.none,
			},
			'h4'
		),
		...CssSelectors.allDescendants(
			{
				margin: spacing.none,
			},
			'p'
		),
		...CssSelectors.allDescendants(
			{
				margin: 0,
			},
			'pre'
		),
	},
	detailsAreaWrap: {
		overflow: 'auto',
		width: '100%',
		maxHeight: 440,
		whiteSpace: 'pre-wrap',
		fontFamily: 'inherit',
	},
	rsvpForm: {
		maxWidth: 1024,
		width: '100%',
	},
	rsvpInfo: {
		'@media only screen and (min-width: 1024px)': {
			flexDirection: 'row',
			justifyContent: 'space-between',
			margin: `${spacing.md}px auto 0`,
			width: '100%',
			gap: spacing.lg,
			...CssSelectors.allChildren(
				{
					width: '100%',
				},
				'div'
			),
		},

		display: 'flex',
		flexDirection: 'column',
		marginTop: spacing.sm,
		paddingTop: spacing.sm,
	},
	formControl: {
		margin: '0 0 16px',
		textAlign: 'left',
		width: '100%',
		...CssSelectors.allChildren(
			{
				color: header,
				fontSize: fontSizes.xs,
			},
			'small'
		),
		...CssSelectors.allChildren(
			{
				width: '100%',
				display: 'block',
				marginBottom: spacing.sm,
				color: colors.text.light,
			},
			'label'
		),
	},
	formControlFullWidth: {
		margin: '0 0 16px',
		textAlign: 'left',
		width: '100%',
	},
	addAnotherGuestButton: {
		color: spanishBlue,
		marginBottom: spacing.sm,
	},
	removeGuestIcon: {
		verticalAlign: 'middle',
	},
	guestInfoError: {
		display: 'flex',
		justifyContent: 'flex-start',
		marginBottom: spacing.sm,
	},
	rsvpOptions: {
		'@media only screen and (min-width: 768px)': {
			flexDirection: 'row',
			margin: `${spacing.lg}px auto ${spacing.lg}px`,
			maxWidth: 1024,
			padding: spacing.lg,
		},
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		marginLeft: 0,
		marginRight: 0,
		marginTop: spacing.lg,
		marginBottom: spacing.lg,
		padding: spacing.md,
	},
	radio: {
		':not(:last-child)': {
			margin: '0 0 12px 0',
		},
		'@media only screen and (min-width: 768px)': {
			':not(:last-child)': {
				margin: '0 12px 0 0',
			},
			margin: 0,
		},
		'@media only screen and (min-width: 1024px)': {
			':not(:last-child)': {
				margin: '0 90px 0 0',
			},
			margin: 0,
		},
	},
	plusOneOptionWrap: {
		'@media only screen and (min-width: 1024px)': {
			margin: '24px auto 0',
			width: '100%',
		},
		display: 'flex',
		flexDirection: 'column',
		marginTop: 24,
	},
	checkbox: {
		gap: 8,
		fontSize: 14,
		color: titles,
	},
	actions: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	buttonContainer: {
		display: 'inline-flex',
		marginBottom: 48,
		marginTop: 48,
	},
	divider: {
		maxWidth: 1024,
		width: '100%',
		borderTop: `2px solid ${nameCircles}`,
	},
	guestInfo: {
		display: 'flex',
		flexDirection: 'row',
		gap: 24,
		alignItems: 'center',
	},
	bringingGuestsLabel: {
		marginLeft: 6,
	},
	textInput: {
		width: '100%',
		boxSizing: 'border-box',
	},
	textArea: {
		height: 68,
	},
	selectBoxtriggerButton: {
		border: `1px solid ${charmGray}`,
		background: hexToRGBA(borderColor, 0.3),
		borderRadius: 8,
	},
	removeGuest: {
		background: 'transparent',
	},
	required: {
		color: destructive,
	},
	paymentInfo: {
		color: titles,
		display: 'flex',
		flexDirection: 'column',
		...CssSelectors.allChildren(
			{
				marginBottom: 16,
			},
			'p'
		),
		...CssSelectors.allDescendants(
			{
				color: titles,
			},
			'strong'
		),
	},
	paymentInfoText: {
		color: titles,
		...CssSelectors.allChildren(
			{
				fontSize: 12,
				color: charmGray,
			},
			'span'
		),
		...CssSelectors.allChildren(
			{
				color: titles,
			},
			'strong'
		),
	},
	disabled: {
		opacity: 0.7,
		pointerEvents: 'none',
	},
	fieldGroup: {
		...Layouts.verticalStack(spacing.md),
	},
	starRating: {
		...Layouts.horizontalStack(4),
		fontSize: 18,
	},
	additionalRecipient: {
		marginBottom: spacing.md,
		minWidth: 417,
		...CssSelectors.allDescendants(
			{
				...CssSelectors.allChildren(
					{
						width: '100%',
					},
					'div:first-child'
				),
			},
			'div'
		),
	},
	removeButton: {
		color: colors.text.main,
		...CssSelectors.allChildren(
			{
				...CssSelectors.allDescendants(
					{
						color: 'transparent',
						fontSize: fontSizes.none,
					},
					'span'
				),
			},
			'span'
		),
	},
	removeButtonIcon: {
		width: 16,
		height: 16,
		color: colors.text.light,
	},
	sectionDescription: {
		color: colors.text.light,
		margin: `0 0 ${spacing.md}px 0`,
		whiteSpace: 'nowrap',
	},
	notificationTitle: {
		marginBottom: spacing.sm,
		width: '100%',
	},
	notificationEmail: {
		width: '100%',
		minWidth: 417,
		...CssSelectors.allChildren(
			{
				':hover': {
					cursor: 'not-allowed',
				},
			},
			'input'
		),
	},
	notificationRecipientInput: {
		width: '100%',
		...CssSelectors.allChildren(
			{
				width: '100%',
			},
			'input'
		),
	},
	tabContent: {
		padding: `0 ${spacing.lg}px ${spacing.xxl}px`,
		margin: `0`,
		...CssSelectors.allChildren(
			{
				padding: `0 ${spacing.lg}px`,
				// margin: `0 -${spacing.lg}px`,
				background: THEME.colors.background.light,
			},
			'div'
		),
		...CssSelectors.allChildren(
			{
				margin: `${spacing.md}px 0`,
			},
			'h3'
		),
	},
	page: {
		background: THEME.colors.background.light,
	},
	notificationSettingsContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.md,
		justifyContent: 'space-between',
		marginTop: spacing.md,
		marginBottom: spacing.lg,
		...CssSelectors.allChildren(
			{
				width: '100%',
				paddingLeft: `${spacing.xs}px`,
			},
			'div'
		),
	},
	notificationSection: {
		marginBottom: spacing.xxxl,
	},
	additionalRecipientsLabel: {
		display: 'block',
		marginBottom: spacing.sm,
		color: colors.text.light,
	},
	sectionHeader: {
		position: 'relative',
		background: colors.background.light,
		boxShadow: `0px 0px 12px ${mention}`,
		marginBottom: spacing.lg,
		zIndex: 1,
		width: '100%',
		maxWidth: 766,
	},
	addButton: {
		backgroundColor: brandPrimary,
		border: 'none',
		borderRadius: 6,
		color: white,
		cursor: 'pointer',
		fontSize: fontSizes.sm,
		padding: `${spacing.sm}px ${spacing.md}px`,
		marginTop: spacing.sm,
		':hover': {
			backgroundColor: brandPrimaryHover,
		},
		':disabled': {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
	},
	settingsContainer: {
		border: common.border,
		borderRadius: common.borderRadius,
		padding: spacing.md,
		backgroundColor: THEME.colors.background.main,
	},
	settingsTabList: {
		paddingTop: spacing.xxl,
	},
	controllerWrapper: {
		maxWidth: 300,
	},
});
